import React from 'react';
import Modal from 'react-modal';

// Shared confirmation for leaving a form with unsaved changes (route blocker or an
// explicit cancel/discard). Cancel is the primary/safe action so it's the default focus.
export default function UnsavedChangesModal({
  isOpen,
  onConfirm,
  onCancel,
  message = 'Any unsaved changes will be lost. Are you sure you want to leave?',
  confirmText = 'Yes, Leave',
  cancelText = 'Cancel',
  contentLabel = 'Unsaved Changes',
}) {
  return (
    <Modal
      className="modal"
      overlayClassName="modalOverlay"
      aria-modal="true"
      contentLabel={contentLabel}
      shouldCloseOnOverlayClick={false}
      isOpen={isOpen}
      onRequestClose={onCancel}
    >
      <div className="modalContent center">
        <p>{message}</p>
      </div>
      <div className="modalButtons">
        <button className="modalButton primaryButton" onClick={onCancel} autoFocus>
          {cancelText}
        </button>
        <button className="modalButton" onClick={onConfirm}>
          {confirmText}
        </button>
      </div>
    </Modal>
  );
}
